<template>
    <div
        class="md-house template8"
        v-if="result && result.listings && result.listings.length > 0"
    >
        <module-box
            :fullColumn="fullColumn"
            :topSpacing="topSpacing"
            :btmSpacing="btmSpacing"
            :mobileTopSpacing="mobileTopSpacing"
            :mobileBtmSpacing="mobileBtmSpacing"
            class="template8-wrapper"
        >
            <div class="house-title" :class="title ? '' : 'no-title'">
                <div class="main-title">
                    <div class="mg-title" v-html="formatFontSize(title, '--mg-title-size')"></div>
                    <a
                        v-if="moreText && !isMobileSize"
                        class="mg-more"
                        :href="moreLink"
                        :aria-label="moreLinkPurpose"
                        :style="moreStyle"
                        rel="noopener noreferrer"
                    >
                        {{ moreText }}
                        <i class="iconfont icon-arrow-up"></i>
                    </a>
                </div>
                <div v-if="desc" class="desc" v-html="desc"></div>
            </div>
            <list />
            <a
                v-if="isMobileSize"
                class="view-all-listings"
                :href="moreLink"
                :aria-label="moreLinkPurpose"
                rel="noopener noreferrer"
            >{{ moreText }} <i class="iconfont icon-arrow-up"></i
            ></a>
        </module-box>
    </div>
</template>
<script>
import Core from '../index.js';
import list from './list.vue';
export default {
    mixins: [Core],
    components: { list },
    data: function() {
        return {};
    },
    methods: {}
};
</script>
<style lang="scss">
@import '@/theme/media.scss';
@import '@/theme/mixin.scss';
.md-house.template8 {
    position: relative;
    background: #212530;
    .template8-wrapper {
        position: relative;
        padding-bottom: 50px;
    }
    .house-title {
        position: relative;
        padding: 0 50px;
        margin-bottom: 30px;
        .main-title {
            width: 100%;
            margin: 0 auto;
        }
        .mg-title {
            color: #fff;
            font-family: var(--font-bold);
            font-size: 24px;
            width: 100%;
            line-height: 24px;
            padding-bottom: 0;
        }
        .desc {
            color: #fff;
            font-size: 16px;
            font-family: var(--font-normal);
            line-height: 24px;
            margin-top: 0;
            margin-bottom: 0;
            p {
                font-family: var(--font-normal);
            }
        }
        .mg-more {
            font-size: 14px;
            color: #fff;
            font-family: var(--font-normal);
        }
        .iconfont.icon-arrow-up {
            display: inline-block;
            transform: rotate(90deg);
            vertical-align: middle;
            font-size: 16px;
        }
    }

    .view-all-listings {
        display: none;
    }
    div.template8-house-swiper{
        position: relative;
    }
    .button-swiper {
        position: absolute;
        z-index: var(--level-low);
        width: 800px;
        height: 60px;
        top: 50%;
        left: 50%;
        transform: translate(-50%,-50%);
        .house-next,
        .house-prev {
            position: absolute;
            width: 60px;
            height: 60px;
            border-radius: 50%;
            line-height: 60px;
            text-align: center;
            cursor: pointer;
            &.house-swiper-disabled,
            &.swiper-button-lock {
                cursor: not-allowed;
                display: block;
            }
        }
        .house-prev {
            background: #fff;
            color: #000;
            left: -30px;
            transform: rotate(-90deg);
            &:active {
                background: #e8e8e8;
            }
            &:hover {
                background: var(--color-theme);
                color:#fff;
            }
            &:disabled {
                background: linear-gradient(
                        0deg,
                        rgba(0, 0, 0, 0.4) 0%,
                        rgba(0, 0, 0, 0.4) 100%
                    ),
                    #fff;
            }
        }
        .house-prev.swiper-button-lock,
        .house-prev.house-swiper-disabled {
            background: linear-gradient(
                    0deg,
                    rgba(0, 0, 0, 0.4) 0%,
                    rgba(0, 0, 0, 0.4) 100%
                ),
                #fff;
        }
        .house-next {
            background: #fff;
            color: #000;
            right: -30px;
            transform: rotate(90deg);
            &:active {
                background: linear-gradient(
                        0deg,
                        rgba(0, 0, 0, 0.1) 0%,
                        rgba(0, 0, 0, 0.1) 100%
                    ),
                    var(--color-theme);
            }
            &:hover {
                background: linear-gradient(
                        0deg,
                        rgba(255, 255, 255, 0.1) 0%,
                        rgba(255, 255, 255, 0.1) 100%
                    ),
                    var(--color-theme);
                color: #fff;
            }
            &:disabled {
                background: linear-gradient(
                        0deg,
                        rgba(0, 0, 0, 0.4) 0%,
                        rgba(0, 0, 0, 0.4) 100%
                    ),
                    var(--color-theme);
            }
        }
        .house-next.swiper-button-lock,
        .house-next.house-swiper-disabled {
            background: linear-gradient(
                    0deg,
                    rgba(0, 0, 0, 0.4) 0%,
                    rgba(0, 0, 0, 0.4) 100%
                ),
                var(--color-theme);
        }
        .iconfont {
            font-size: 24px;
        }
        .swiper-button-lock::before,
        .house-swiper-disabled::before {
            opacity: 0.3;
        }
    }

    .swiper {
        margin-left: auto;
        margin-right: auto;
        position: relative;
    }
    .swiper-wrapper {
        position: relative;
        width: 100%;
        height: 100%;
        z-index: 1;
        transition-property: transform;
        display: flex;
        align-items: center;
    }
    .swiper-slide {
        transition-duration: 0ms;
        width: 800px;
        z-index: 0;
        .house-slider-item {
            width: 100%;
            height: 560px;
            .house-info{
                // display: none;
            }
        }
    }
    .swiper-slide-active {
        z-index: 1;
        .house-slider-item {
            .house-info{
                // display: block;
            }
        }
    }

    @include media-800 {
        .swiper-slide {
            width: 300px;
            z-index: 0;
            .house-slider-item {
                width: 100%;
                height: 410px;

                .house-preview {
                    .house-info {
                        overflow: hidden;
                    }
                }
            }
        }
    }

    @include media-800 {
        .template8-wrapper {
            position: relative;
            padding-top: 5px;
            padding-bottom: 25px;
        }
        .main-title {
            padding-top: 10px;
            line-height: 30;
        }
        .house-title {
            padding: 0 15px;
            margin-bottom: 15px;
            .mg-title {
                font-size: 16px;
                padding-bottom: 0;
            }
        }

        .view-all-listings {
            display: block;
            color: #fff;
            text-align: center;
            font-family: var(--font-normal);
            font-size: 14px;
            font-weight: 400;
            margin-top: 20px;
            margin-bottom: 5px;
            .iconfont.icon-arrow-up {
                display: inline-block;
                transform: rotate(90deg);
                vertical-align: middle;
                font-size: 16px;
            }
        }
    }
}
</style>
